import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { MarketFacilityFormResponseFacilityDtoSchema } from '../contracts';

export const SearchMarketFacilityFormsRequestDtoSchema = z.object({
  dba: z.string().optional(),
  name: z.string().optional(),
  lat: z.number().optional(),
  lng: z.number().optional(),
});

const SearchMarketFacilityFormsResponseDtoSchema = z.array(
  MarketFacilityFormResponseFacilityDtoSchema
);

export type SearchMarketFacilityFormsRequestDto = z.infer<
  typeof SearchMarketFacilityFormsRequestDtoSchema
>;
export type SearchMarketFacilityFormsResponseDto = z.infer<
  typeof SearchMarketFacilityFormsResponseDtoSchema
>;

export const searchMarketFacilityForms = (
  params: SearchMarketFacilityFormsRequestDto,
  config?: AxiosRequestConfig<SearchMarketFacilityFormsRequestDto>
) => {
  return api
    .get('/market-facilities/form/search', {
      params,
      ...config,
    })
    .then(responseContract(SearchMarketFacilityFormsResponseDtoSchema));
};
